import React from 'react';
import { Map } from 'lucide-react';

export function MapSkeleton({ error }: { error?: string | null }) {
  if (error) {
    return (
      <div className="flex-1 flex items-center justify-center bg-slate-100">
        <div className="text-center p-4">
          <Map className="w-10 h-10 text-slate-300 mx-auto mb-2" />
          <p className="text-sm text-slate-500">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 flex items-center justify-center bg-slate-100 animate-pulse">
      <div className="text-center">
        <Map className="w-10 h-10 text-slate-300 mx-auto mb-2" />
        <p className="text-xs text-slate-400">Loading map...</p>
      </div>
    </div>
  );
}
